import { ApolloProvider } from "@apollo/client/react";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { getClient } from "./graphql/client";
import "./index.css";
import { initializeOffice } from "./office";

const theme = createTheme();

initializeOffice().then(() => {
  const root = document.getElementById("root");
  if (!root) throw new Error("Root element not found");

  createRoot(root).render(
    <StrictMode>
      <ApolloProvider client={getClient()}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </ApolloProvider>
    </StrictMode>,
  );
});
